import React from 'react';

// Bot search targets, as entered on the client machine. Keys vary per run, so
// only the columns actually present are rendered.
const CRITERIA_COLUMNS = [
  { key: 'shdate', label: 'Date' },
  { key: 'ShTagSetCdName', label: 'Tag' },
  { key: 'tmstart', label: 'Start', format: fmtCriteriaTime },
  { key: 'tmstartOperator', label: 'Start Match' },
  { key: 'tmend', label: 'End', format: fmtCriteriaTime },
  { key: 'SiteName', label: 'Site' }
];

// Times come through as bare digits ("900", "1800") — show them as clock times.
function fmtCriteriaTime(v) {
  const digits = String(v).replace(/[^0-9]/g, '');
  if (digits.length < 3 || digits.length > 4) return String(v);
  return `${digits.slice(0, -2).padStart(2, '0')}:${digits.slice(-2)}`;
}

function CriteriaDetail({ criteria, stacked }) {
  const rows = criteria || [];
  const known = CRITERIA_COLUMNS.filter(c => rows.some(r => r && r[c.key] != null && r[c.key] !== ''));
  // Anything the bot sends that we don't have a column for still gets shown.
  const extras = [...new Set(rows.flatMap(r => Object.keys(r || {})))]
    .filter(k => !CRITERIA_COLUMNS.some(c => c.key === k));
  const columns = [...known, ...extras.map(k => ({ key: k, label: k }))];

  // null means "the bot didn't send this one" — both layouts show it as a dash.
  const cellValue = (cr, c) => {
    const raw = cr ? cr[c.key] : undefined;
    if (raw == null || raw === '') return null;
    if (typeof raw === 'object') return JSON.stringify(raw);
    return c.format ? c.format(raw) : String(raw);
  };

  // Phone layout: each target becomes a label/value block, so the columns stack
  // down the screen instead of running off the right edge.
  if (stacked) {
    return (
      <div className="criteria-stack">
        {rows.map((cr, i) => (
          <div key={i} className="criteria-stack-item">
            <div className="criteria-stack-num">Target {i + 1}</div>
            <dl className="criteria-stack-fields">
              {columns.map(c => {
                const value = cellValue(cr, c);
                return (
                  <React.Fragment key={c.key}>
                    <dt>{c.label}</dt>
                    <dd style={{ color: value == null ? '#a0aec0' : undefined }}>{value == null ? '—' : value}</dd>
                  </React.Fragment>
                );
              })}
            </dl>
          </div>
        ))}
      </div>
    );
  }

  return (
    <table style={{ minWidth: 0, width: 'auto', fontSize: 12, background: '#ffffff', border: '1px solid #e2e8f0' }}>
      <thead>
        <tr>
          <th style={{ fontSize: 11 }}>#</th>
          {columns.map(c => <th key={c.key} style={{ fontSize: 11, whiteSpace: 'nowrap' }}>{c.label}</th>)}
        </tr>
      </thead>
      <tbody>
        {rows.map((cr, i) => (
          <tr key={i}>
            <td style={{ color: '#a0aec0' }}>{i + 1}</td>
            {columns.map(c => {
              const value = cellValue(cr, c);
              return (
                <td key={c.key} style={{ whiteSpace: 'nowrap', color: value == null ? '#a0aec0' : undefined }}>{value == null ? '—' : value}</td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default CriteriaDetail;
